import React from 'react';
import { Layers, Info } from 'lucide-react';

const TrancheInvestmentSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  investmentFrequencies
}) => {
  if (!formData.hasTranchesInvestment) {
    return (
      <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
        <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
          <Layers className="w-5 h-5 mr-2 text-purple-500" />
          Инвестирование траншами
        </h3>
        
        <div className="mb-2">
          <div className="flex items-start">
            <div className="flex items-center h-5">
              <input
                id="hasTranchesInvestment"
                name="hasTranchesInvestment"
                type="checkbox"
                checked={formData.hasTranchesInvestment}
                onChange={handleInputChange}
                className="form-checkbox"
              />
            </div>
            <div className="ml-3 text-sm">
              <label htmlFor="hasTranchesInvestment" className="font-medium text-gray-700 dark:text-gray-300">
                Разбить инвестицию на транши
              </label>
              <p className="text-gray-500 dark:text-gray-400">
                Инвестирование не всей суммы сразу, а частями с определенной периодичностью
              </p>
            </div>
          </div>
          {errors.hasTranchesInvestment && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.hasTranchesInvestment}
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Layers className="w-5 h-5 mr-2 text-purple-500" />
        Инвестирование траншами
      </h3>
      
      <div className="mb-2">
        <div className="flex items-start">
          <div className="flex items-center h-5">
            <input
              id="hasTranchesInvestment"
              name="hasTranchesInvestment"
              type="checkbox"
              checked={formData.hasTranchesInvestment}
              onChange={handleInputChange}
              className="form-checkbox"
            />
          </div>
          <div className="ml-3 text-sm">
            <label htmlFor="hasTranchesInvestment" className="font-medium text-gray-700 dark:text-gray-300">
              Разбить инвестицию на транши
            </label>
            <p className="text-gray-500 dark:text-gray-400">
              Инвестирование не всей суммы сразу, а частями с определенной периодичностью
            </p>
          </div>
        </div>
        {errors.hasTranchesInvestment && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.hasTranchesInvestment}
          </p>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        {/* Количество траншей */}
        <div>
          <label htmlFor="tranchesCount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Количество траншей
          </label>
          <input
            type="number"
            id="tranchesCount"
            name="tranchesCount"
            value={formData.tranchesCount}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.tranchesCount ? 'input-error' : ''}`}
            min="2"
            max="100"
          />
          {errors.tranchesCount && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.tranchesCount}
            </p>
          )}
        </div>

        {/* Периодичность траншей */}
        <div>
          <label htmlFor="tranchesFrequency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Периодичность траншей
          </label>
          <select
            id="tranchesFrequency"
            name="tranchesFrequency"
            value={formData.tranchesFrequency}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.tranchesFrequency ? 'input-error' : ''}`}
          >
            {investmentFrequencies.map((frequency) => (
              <option key={frequency.id} value={frequency.id}>
                {frequency.name}
              </option>
            ))}
          </select>
          {errors.tranchesFrequency && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.tranchesFrequency}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-purple-100 dark:bg-purple-900/30 p-3 rounded-lg border border-purple-200 dark:border-purple-800">
        <div className="flex items-start">
          <Info className="w-5 h-5 text-purple-600 dark:text-purple-400 mr-3 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-purple-700 dark:text-purple-300 mb-1">
              Преимущества транша
            </h4>
            <p className="text-xs text-purple-600 dark:text-purple-400">
              Инвестирование траншами снижает риски неудачного входа в рынок и позволяет использовать преимущество 
              усреднения цены покупки (DCA). Первая часть инвестиции будет вложена сразу, а оставшиеся транши - 
              распределены в соответствии с выбранной периодичностью.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrancheInvestmentSection;